var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check-circle']}}),_vm._v(" "+_vm._s(_vm.msgExito)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }